import {
    OpenRegular,
    NotepadPersonRegular,
    GuestRegular,
    GlobePersonRegular,
    PersonRegular,
    PersonTagRegular,
    StorageRegular,
    DocumentOnePageLinkRegular,
    ShareRegular,
    DocumentDatabaseRegular,
    HomeDatabaseRegular,
    DatabaseRegular,
    PersonQuestionMarkRegular,
    DocumentSearchRegular,
    MailProhibitedRegular,
    CloudLinkRegular,
    LinkPersonRegular,
    ArrowTrendingLinesRegular,
    DocumentGlobeRegular,
    DocumentPersonRegular,
    AppsSettingsRegular,
    NotepadRegular
} from "@fluentui/react-icons";
import { INavItemV3 } from "@interfaces/common.interfaces";
import { PPAPermissions } from "./permissions";


const navItems: Array<INavItemV3> = [
    {
        id: "1",
        key: "1",
        route: "/reports",
        label: "ppaReportsTitle",
        //description: "These are the reports available to run in your tenant.",
        description: "ppaReportsDescription",
        icon: DocumentSearchRegular,
        //isReport: false,
        //enabled: true
        onTopNav: true
    },
    {
        id: "1.1",
        key: "1.1",
        route: "/reports/guest-users",
        label: "ppaGuestUsersReportGroupTitle",
        //description: "These reports will identify the guest users in your tenant and the areas they have access to.",
        description: "ppaGuestUsersReportGroupDescription",
        icon: GuestRegular,
        permissions: PPAPermissions.ViewGuestUsersReportGroup,
        //isReport: false,
        //enabled: true,
        parentId: "1"
    },
    {
        id: "1.1.1",
        key: "GuestUsersInTenantReport",
        route: "/reports/guest-users/guest-users-tenant",
        label: "ppaGuestUsersInTenantReportTitle",
        //description: "Reports on all the guest users across the M365 tenant and the role they have been assigned.",
        description: "ppaGuestUsersInTenantReportDescription",
        icon: GlobePersonRegular,
        permissions: PPAPermissions.RequestGuestUsersInTenantReport,
        //isReport: true,
        //enabled: true,
        parentId: "1.1"
    },
    {
        id: "1.1.2",
        key: "GuestUsersInWorkspaceReport",
        route: "/reports/guest-users/guest-users-workspace",
        label: "ppaGuestUsersInWorkspaceReportTitle",
        //description: "Reports on the guest users in a specific workspace and the role they have been assigned.",
        description: "ppaGuestUsersInWorkspaceReportDescription",
        icon: NotepadPersonRegular,
        permissions: [PPAPermissions.RequestGuestUsersInWorkspaceReportAny], // Not yet implemented: PPAPermissions.RequestGuestUsersInWorkspaceReportMineOnly
        //isReport: true,
        //enabled: true,
        parentId: "1.1"
    },
    {
        id: "1.1.3",
        key: "GuestUserReport",
        route: "/reports/guest-users/guest-users-user",
        label: "ppaGuestUserReportTitle",
        //description: "Reports on the permissions assigned to a specific guest user across all the workspaces in the M365 tenant.",
        description: "ppaGuestUserReportDescription",
        icon: PersonRegular,
        permissions: PPAPermissions.RequestGuestUserReport,
        //isReport: true,
        //enabled: true,
        parentId: "1.1"
    },
    {
        id: "1.1.4",
        key: "GuestUsersInWorkspacesByOwnerReport",
        route: "/reports/guest-users/guest-users-workspaces-by-owner",
        label: "ppaGuestUsersInWorkspacesByOwnerReportTitle",
        //description: "Reports on the guest users in a specific workspace and the role they have been assigned.",
        description: "ppaGuestUsersInWorkspacesByOwnerReportDescription",
        icon: PersonTagRegular,
        permissions: [PPAPermissions.RequestGuestUsersInWorkspacesByOwnerReportAny, PPAPermissions.RequestGuestUsersInWorkspacesByOwnerReportMineOnly],
        //isReport: true,
        //enabled: true,
        parentId: "1.1"
    },
    {
        id: "1.2",
        key: "1.2",
        route: "/reports/sharing-links",
        label: "ppaSharingLinksReportGroupTitle",
        //description: "The reports for sharing links in the tenant.",
        description: "ppaSharingLinksReportGroupDescription",
        icon: OpenRegular,
        permissions: PPAPermissions.ViewSharingLinksReportGroup,
        //isReport: false,
        //enabled: true,
        parentId: "1",
        disabled: false
    },
    {
        id: "1.2.1",
        key: "SharingLinksInTenantReport",
        route: "/reports/sharing-links/sharing-links-tenant",
        label: "ppaSharingLinksInTenantReportTitle",
        //description: "Reports on all the sharing links across the M365 tenant.",
        description: "ppaSharingLinksInTenantReportDescription",
        icon: ShareRegular,
        permissions: PPAPermissions.RequestSharingLinksInTenantReport,
        //isReport: false,
        //enabled: true,
        parentId: "1.2",
        disabled: false
    },
    {
        id: "1.2.2",
        key: "SharingLinksInWorkspaceReport",
        route: "/reports/sharing-links/sharing-links-workspace",
        label: "ppaSharingLinksInWorkspaceReportTitle",
        //description: "Reports on the sharing links in a specific workspace and who they have been shared with.",
        description: "ppaSharingLinksInWorkspaceReportDescription",
        icon: DocumentOnePageLinkRegular,
        permissions: [PPAPermissions.RequestSharingLinksInWorkspaceReportAny], // Not yet implemented: PPAPermissions.RequestSharingLinksInWorkspaceReportMineOnly
        //isReport: false,
        //enabled: true,
        parentId: "1.2",
        disabled: false
    },
    {
        id: "1.2.3",
        key: "SharingLinksInOneDriveReport",
        route: "/reports/sharing-links/sharing-links-onedrive",
        label: "ppaSharingLinksInOneDriveReportTitle",
        description: "ppaSharingLinksInOneDriveReportDescription",
        icon: CloudLinkRegular,
        permissions: [PPAPermissions.RequestSharingLinksInOneDriveReportAny, PPAPermissions.RequestSharingLinksInOneDriveReportMineOnly],
        //isReport: false,
        //enabled: true,
        parentId: "1.2",
        disabled: false
    },
    {
        id: "1.2.4",
        key: "SharingLinksInWorkspacesByOwnerReport",
        route: "/reports/sharing-links/sharing-links-workspaces-by-owner",
        label: "ppaSharingLinksInWorkspacesByOwnerReportTitle",
        description: "ppaSharingLinksInWorkspacesByOwnerReportDescription",
        icon: LinkPersonRegular,
        permissions: [PPAPermissions.RequestSharingLinksInWorkspacesByOwnerReportAny, PPAPermissions.RequestSharingLinksInWorkspacesByOwnerReportMineOnly],
        //isReport: false,
        //enabled: true,
        parentId: "1.2",
        disabled: false
    },
    {
        id: "1.3",
        key: "1.3",
        route: "/reports/storage",
        label: "ppaStorageReportGroupTitle",
        //description: "The reports on storage capacity and usage in the tenant.",
        description: "ppaStorageReportGroupDescription",
        icon: DatabaseRegular,
        permissions: PPAPermissions.ViewStorageReportGroup,
        //isReport: false,
        //enabled: true,
        parentId: "1",
        disabled: false
    },
    {
        id: "1.3.1",
        key: "StorageInTenantReport",
        route: "/reports/storage/storage-tenant",
        label: "ppaStorageInTenantReportTitle",
        //description: "Reports on the storage capacity and usage across the M365 tenant.",
        description: "ppaStorageInTenantReportDescription",
        icon: HomeDatabaseRegular,
        permissions: PPAPermissions.RequestStorageInTenantReport,
        //isReport: false,
        //enabled: true,
        parentId: "1.3",
        disabled: false
    },
    {
        id: "1.3.2",
        key: "StorageInWorkspaceReport",
        route: "/reports/storage/storage-workspace",
        label: "ppaStorageInWorkspaceReportTitle",
        //description: "Reports on the storage capacity and usage in a specific workspace.",
        description: "ppaStorageInWorkspaceReportDescription",
        icon: DocumentDatabaseRegular,
        permissions: [PPAPermissions.RequestStorageInWorkspaceReportAny], // Not yet implemented: PPAPermissions.RequestStorageInWorkspaceReportMineOnly
        //isReport: false,
        //enabled: true,
        parentId: "1.3",
        disabled: false
    },
    {
        id: "1.3.3",
        key: "StorageInOneDriveReport",
        route: "/reports/storage/storage-onedrive",
        label: "ppaStorageInOneDriveReportTitle",
        description: "ppaStorageInOneDriveReportDescription",
        icon: CloudLinkRegular,
        permissions: [PPAPermissions.RequestStorageInOneDriveReportAny, PPAPermissions.RequestStorageInOneDriveReportMineOnly],
        parentId: "1.3",
        disabled: false
    },
    {
        id: "1.4",
        key: "1.4",
        route: "/reports/orphaned-objects",
        label: "ppaOrphanedObjectsReportGroupTitle",
        //description: "The reports on orphaned objects across the tenant.",
        description: "ppaOrphanedObjectsReportGroupDescription",
        icon: PersonQuestionMarkRegular,
        permissions: PPAPermissions.ViewOrphanedObjectsReportGroup,
        //isReport: false,
        //enabled: true,
        parentId: "1",
        disabled: false
    },
    {
        id: "1.4.1",
        key: "OrphanedUsersInTenantReport",
        route: "/reports/orphaned-objects/orphaned-users-tenant",
        label: "ppaOrphanedUsersInTenantReportTitle",
        //description: "Reports on the orphaned users in SharePoint sites across the M365 tenant.",
        description: "ppaOrphanedUsersInTenantReportDescription",
        icon: PersonQuestionMarkRegular,
        permissions: PPAPermissions.RequestOrphanedUsersInTenantReport,
        //isReport: false,
        //enabled: true,
        parentId: "1.4",
        disabled: false
    },
    {
        id: "1.4.2",
        key: "OrphanedMailboxesInTenantReport",
        route: "/reports/orphaned-objects/orphaned-mailboxes-tenant",
        label: "ppaOrphanedMailboxesInTenantReportTitle",
        //description: "Reports on the orphaned mailboxes in Exchange across the M365 tenant.<br/>An orhpaned mailbox is a mailbox that is assigned to a single user and the user is disabled in Entra ID.",
        description: "ppaOrphanedMailboxesInTenantReportDescription",
        icon: MailProhibitedRegular,
        permissions: PPAPermissions.RequestOrphanedMailboxesInTenantReport,
        //isReport: false,
        //enabled: true,
        parentId: "1.4",
        disabled: false
    },
    {
        id: "1.4.3",
        key: "OrphanedWorkspacesInTenantReport",
        route: "/reports/orphaned-objects/orphaned-workspaces-tenant",
        label: "ppaOrphanedWorkspacesInTenantReportTitle",
        description: "ppaOrphanedWorkspacesInTenantReportDescription",
        icon: GlobePersonRegular,
        permissions: PPAPermissions.RequestOrphanedWorkspacesInTenantReport,
        //isReport: false,
        //enabled: true,
        parentId: "1.4",
        disabled: false
    },
    {
        id: "1.5",
        key: "1.5",
        route: "/reports/usage-reports",
        label: "ppaUsageReportsGroupTitle",
        description: "ppaUsageReportsGroupDescription",
        icon: ArrowTrendingLinesRegular,
        permissions: PPAPermissions.ViewUsageReportsGroup,
        parentId: "1",
        disabled: false
    },
    {
        id: "1.5.1",
        key: "InactiveWorkspacesInTenantReport",
        route: "/reports/usage-reports/inactive-workspaces-tenant",
        label: "ppaInactiveWorkspacesInTenantReportTitle",
        description: "ppaInactiveWorkspacesInTenantReportDescription",
        icon: DocumentGlobeRegular,
        permissions: PPAPermissions.RequestInactiveWorkspacesInTenantReport,
        parentId: "1.5",
        disabled: false
    },
    {
        id: "1.5.2",
        key: "InactiveWorkspacesByOwnerReport",
        route: "/reports/usage-reports/inactive-workspaces-by-owner",
        label: "ppaInactiveWorkspacesByOwnerReportTitle",
        description: "ppaInactiveWorkspacesByOwnerReportDescription",
        icon: DocumentPersonRegular,
        permissions: [PPAPermissions.RequestInactiveWorkspacesByOwnerReportAny, PPAPermissions.RequestInactiveWorkspacesByOwnerReportMineOnly],
        parentId: "1.5",
        disabled: false
    },
    {
        id: "1.6",
        key: "1.6",
        route: "/reports/summary-reports",
        label: "ppaSummaryReportsGroupTitle",
        description: "ppaSummaryReportsGroupDescription",
        icon: AppsSettingsRegular,
        permissions: PPAPermissions.ViewSummaryReportsGroup,
        parentId: "1",
        disabled: false
    },
    {
        id: "1.6.1",
        key: "WorkspaceSummaryInTenantReport",
        route: "/reports/summary-reports/workspace-summary-tenant",
        label: "ppaWorkspaceSummaryInTenantReportTitle",
        description: "ppaWorkspaceSummaryInTenantReportDescription",
        icon: NotepadRegular,
        permissions: PPAPermissions.RequestWorkspaceSummaryInTenantReport,
        parentId: "1.6",
        disabled: false
    },
    {
        id: "1.6.2",
        key: "WorkspaceSummaryByOwnerReport",
        route: "/reports/summary-reports/workspace-summary-by-owner",
        label: "ppaWorkspaceSummaryByOwnerReportTitle",
        description: "ppaWorkspaceSummaryByOwnerReportDescription",
        icon: NotepadPersonRegular,
        permissions: [PPAPermissions.RequestWorkspaceSummaryByOwnerReportAny, PPAPermissions.RequestWorkspaceSummaryByOwnerReportMineOnly],
        parentId: "1.6",
        disabled: false
    },
    {
        id: "1.7",
        key: "1.7",
        route: "/reports/file-size-reports",
        label: "ppaFileSizeReportsGroupTitle",
        description: "ppaFileSizeReportsGroupDescription",
        icon: DocumentDatabaseRegular,
        permissions: PPAPermissions.ViewFileSizeReportsGroup,
        parentId: "1",
        disabled: false
    },
    {
        id: "1.7.1",
        key: "FileSizeInTenantReport",
        route: "/reports/file-size-reports/file-size-tenant",
        label: "ppaFileSizeInTenantReportTitle",
        description: "ppaFileSizeInTenantReportDescription",
        icon: DocumentGlobeRegular,
        permissions: PPAPermissions.RequestFileSizeInTenantReport,
        parentId: "1.7",
        disabled: false
    },
    // {
    //     id: "2",
    //     route: "/actions",
    //     label: "ppaActionsTitle",
    //     description: "You can perform certain actions.",
    //     //showAsCard: true
    //     //onTopNav: true
    //     disabled: true
    // },
    {
        id: "3",
        key: "3",
        route: "/report-requests",
        label: "ppaReportRequestsTitle",
        //onTopNav: true
        disabled: true
    },
    {
        id: "4",
        key: "4",
        route: "/action-requests",
        label: "ppaActionRequestsTitle",
        //onTopNav: true
        disabled: true
    },
    {
        id: "5",
        key: "5",
        route: "/about",
        label: "about",
        //onTopNav: true
        disabled: true
    },
    {
        id: "6",
        key: "6",
        route: "/settings",
        label: "settings",
        disabled: true,
        permissions: PPAPermissions.ViewSettings
    },
    {
        id: "6.1",
        key: "settingsPermissions",
        route: "/settings/permissions",
        label: "permissions",
        parentId: "6",
        disabled: false,
        permissions: PPAPermissions.ViewPermissionSettings
    },
    {
        id: "6.1.1",
        key: "settingsPermissions1",
        route: "/settings/permissions/application-roles",
        label: "ppaApplicationRolesTitle",
        description: "ppaApplicationRolesDescription",
        parentId: "6.1",
        disabled: false,
        permissions: PPAPermissions.ViewApplicationRoles
    },
    {
        id: "6.1.2",
        key: "settingsPermissions2",
        route: "/settings/permissions/role-assignments",
        label: "ppaApplicationRoleAssignmentsTitle",
        description: "ppaApplicationRoleAssignmentsDescription",
        parentId: "6.1",
        disabled: true,
        permissions: PPAPermissions.ViewApplicationRoleAssignments
    },
    {
        id: "6.1.3",
        key: "settingsPermissions3",
        route: "/settings/permissions/m365-entra-id",
        label: "ppaM365EntraIDPermissionsTitle",
        description: "ppaM365EntraIDPermissionsDescription",
        parentId: "6.1",
        disabled: false,
        permissions: PPAPermissions.ViewMicrosoftEntraIDPermissions
    }
]

export default navItems;